jQuery(document).ready(function () {
  jQuery(".rio-largo-page-title button").on("click", function () {
    var section = $(this).closest(".rio-largo-page-title");
    var video = section.find("video").get(0);

    // Add class to toggle visibility
    section.addClass("video-playing");

    // Play video
    if (video) {
      video.play();
    }
  });
  jQuery('.custom-featured-collection .collection-wrapper').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: jQuery('.collection-nav.prev'),
    nextArrow: jQuery('.collection-nav.next'),
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  jQuery('.our-partners-section .logos-wrapper').slick({
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
        }
      }
    ]
  });
		
});